import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { toast } from 'react-toastify';
import { getPlanos, savePlano, getUnidades } from '../services/api';
import ResponsiveListTable from '../components/ResponsiveListTable';

/* ==== Ícones (SVG inline) ==== */
const ListTodo = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M12 20h.01"/><path d="M17 12h.01"/><path d="M7 12h.01"/><path d="M3 17h.01"/><path d="M3 7h.01"/><path d="M7 17h.01"/><path d="M12 12h.01"/><path d="M17 17h.01"/><path d="M21 17h.01"/><path d="M21 12h.01"/><path d="M21 7h.01"/><path d="M17 7h.01"/><path d="M12 7h.01"/><path d="M7 7h.01"/></svg>
);
const AlertCircle = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
);
const CheckCircle2 = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"/><path d="m9 12 2 2 4-4"/></svg>
);
const Search = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>
);
const Edit = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
);

/* ==== Modal Criar/Editar ==== */
const PlanoAcaoModal = ({ open, onClose, onSave, plano, unidades = [] }) => {
  const [formData, setFormData] = useState({
    descricao: '',
    responsavel: '',
    data_vencimento: '',
    status: 'PENDENTE',
    unidade_id: '',
  });

  useEffect(() => {
    if (!open) return;
    if (plano) {
      setFormData({
        descricao: plano.descricao || '',
        responsavel: plano.responsavel || '',
        data_vencimento: plano.data_vencimento ? new Date(plano.data_vencimento).toISOString().split('T')[0] : '',
        status: plano.status || 'PENDENTE',
        unidade_id: plano.unidade_id || plano.checklist_respostas?.checklist_execucoes?.unidade_id || '',
      });
    } else {
      setFormData({ descricao: '', responsavel: '', data_vencimento: '', status: 'PENDENTE', unidade_id: '' });
    }
  }, [plano, open]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.descricao) {
      toast.warn('Descrição, é obrigatória.');
      return;
    }
    onSave({ ...plano, ...formData });
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl p-8 w-full max-w-lg">
        <h2 className="text-2xl font-bold text-gray-800 mb-6">{plano ? 'Editar Tarefa' : 'Nova Tarefa'}</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Descrição da Tarefa</label>
            <textarea
              name="descricao"
              value={formData.descricao}
              onChange={handleChange}
              rows="3"
              className="mt-1 w-full border border-gray-300 rounded-md shadow-sm focus:ring-purple-500 focus:border-purple-500"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Unidade</label>
            <select
              name="unidade_id"
              value={formData.unidade_id}
              onChange={handleChange}
              className="mt-1 w-full border border-gray-300 rounded-md shadow-sm focus:ring-purple-500 focus:border-purple-500 py-2 px-3"
            >
              <option value="">Selecione</option>
              {unidades.map((u) => (
                <option key={u.unidade_id} value={u.unidade_id}>
                  {u.nome}
                </option>
              ))}
            </select>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Responsável</label>
              <input
                type="text"
                name="responsavel"
                value={formData.responsavel}
                onChange={handleChange}
                className="mt-1 w-full border border-gray-300 rounded-md shadow-sm focus:ring-purple-500 focus:border-purple-500 py-2 px-3"
                placeholder="Nome do responsável"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Prazo</label>
              <input
                type="date"
                name="data_vencimento"
                value={formData.data_vencimento}
                onChange={handleChange}
                className="mt-1 w-full border border-gray-300 rounded-md shadow-sm focus:ring-purple-500 focus:border-purple-500 py-1.5 px-3"
              />
            </div>
          </div>
          <div className="flex justify-end space-x-3 pt-4">
            <button type="button" onClick={onClose} className="bg-gray-200 text-gray-700 font-semibold py-2 px-4 rounded-lg hover:bg-gray-300">
              Cancelar
            </button>
            <button type="submit" className="bg-purple-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-purple-700">
              Salvar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

/* ==== Cards de resumo ==== */
const SummaryCard = ({ title, value, icon, colorClass }) => (
  <div className="bg-white p-6 rounded-xl shadow-md flex items-center space-x-4 border border-gray-100">
    <div className={`p-3 rounded-full ${colorClass}`}>{icon}</div>
    <div>
      <p className="text-gray-500 text-sm font-medium">{title}</p>
      <p className="text-2xl font-bold text-gray-800">{value}</p>
    </div>
  </div>
);

/* ==== Badge de Status ==== */
const StatusBadge = ({ status }) => {
  const statusStyles = {
    PENDENTE: 'bg-yellow-100 text-yellow-800',
    EM_ANDAMENTO: 'bg-purple-100 text-purple-800',
    CONCLUIDA: 'bg-green-100 text-green-800',
    ATRASADO: 'bg-red-200 text-red-900 font-bold',
  };
  const statusText = {
    PENDENTE: 'Pendente',
    EM_ANDAMENTO: 'Em Andamento',
    CONCLUIDA: 'Concluída',
    ATRASADO: 'Atrasado',
  };
  const key = status === 'ATRASADO' ? 'ATRASADO' : String(status || '').toUpperCase();
  return <span className={`px-3 py-1 text-xs font-semibold rounded-full ${statusStyles[key] || 'bg-gray-100 text-gray-800'}`}>{statusText[key] || status}</span>;
};

/* ==== Página ==== */
const PlanosPage = () => {
  const [planos, setPlanos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [unidades, setUnidades] = useState([]);

  const [statusFilter, setStatusFilter] = useState('PENDENTES');
  const [searchTerm, setSearchTerm] = useState('');

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentPlano, setCurrentPlano] = useState(null);

  const loadData = useCallback(async () => {
    try {
      setLoading(true);
      const planosData = await getPlanos();
      const normalized = planosData.map(p => {
        const atrasado = p.data_vencimento && new Date(p.data_vencimento) < new Date() && String(p.status).toUpperCase() !== 'CONCLUIDA';
        return { ...p, status: atrasado ? 'ATRASADO' : String(p.status).toUpperCase() };
      });
      setPlanos(normalized);
    } catch (err) {
      toast.error('Erro ao carregar dados.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, []);

  const loadUnidades = useCallback(async () => {
    try {
      const data = await getUnidades();
      setUnidades(Array.isArray(data) ? data : []);
    } catch (err) {
      toast.error('Erro ao carregar unidades.');
      console.error(err);
    }
  }, []);

  useEffect(() => {
    loadData();
    loadUnidades();
  }, [loadData, loadUnidades]);

  const summaryData = useMemo(() => {
    const pendentes = planos.filter(p => ['PENDENTE', 'EM_ANDAMENTO'].includes(p.status)).length;
    const atrasadas = planos.filter(p => p.status === 'ATRASADO').length;
    const concluidas = planos.filter(p => p.status === 'CONCLUIDA').length;
    return { pendentes, atrasadas, concluidas };
  }, [planos]);

  const filteredPlanos = useMemo(() => {
    const term = searchTerm.trim().toLowerCase();
    return planos.filter(plano => {
      const statusMatch =
        statusFilter === 'TODOS' ||
        (statusFilter === 'PENDENTES' && ['PENDENTE', 'EM_ANDAMENTO', 'ATRASADO'].includes(plano.status)) ||
        plano.status === statusFilter;

      const origemPerg = plano.checklist_respostas?.checklist_perguntas_modelo?.texto_pergunta || '';
      const unidadeNome =
        plano.checklist_respostas?.checklist_execucoes?.unidades?.nome ||
        plano.unidade?.nome ||
        unidades.find(
          (u) =>
            u.unidade_id ===
            (plano.unidade_id || plano.checklist_respostas?.checklist_execucoes?.unidade_id)
        )?.nome ||
        '';

      const searchMatch =
        plano.descricao.toLowerCase().includes(term) ||
        (plano.responsavel || '').toLowerCase().includes(term) ||
        origemPerg.toLowerCase().includes(term) ||
        unidadeNome.toLowerCase().includes(term);

      return statusMatch && searchMatch;
    });
  }, [planos, statusFilter, searchTerm, unidades]);

  const handleOpenModal = useCallback((plano = null) => {
    setCurrentPlano(plano);
    setIsModalOpen(true);
  }, []);
  const handleCloseModal = useCallback(() => {
    setCurrentPlano(null);
    setIsModalOpen(false);
  }, []);

  const handleSavePlano = async (planoData) => {
    try {
      const payload = {
        descricao: planoData.descricao,
        responsavel: planoData.responsavel,
        data_vencimento: planoData.data_vencimento,
        status: planoData.status,
        unidade_id: planoData.unidade_id,
        ...(planoData.plano_acao_id ? { plano_acao_id: planoData.plano_acao_id } : {}),
      };
      await savePlano(payload);
      toast.success(payload.plano_acao_id ? 'Tarefa atualizada com sucesso!' : 'Tarefa criada com sucesso!');
      handleCloseModal();
      loadData();
    } catch (err) {
      toast.error('Erro ao salvar tarefa.');
      console.error(err);
    }
  };

  const handleUpdateStatus = useCallback(async (plano, newStatus) => {
    try {
      await savePlano({ ...plano, status: newStatus });
      toast.success(`Tarefa marcada como ${newStatus.toLowerCase()}!`);
      loadData();
    } catch (err) {
      toast.error('Erro ao atualizar status da tarefa.');
      console.error(err);
    }
  }, [loadData]);

  /* === Colunas para o ResponsiveListTable === */
  const columns = useMemo(() => {
    return [
      {
        key: 'tarefa',
        header: 'Tarefa & Origem',
        className: 'align-top',
        render: (row) => (
          <div>
            <p className="font-bold text-gray-800">{row.descricao}</p>
            <p className="text-xs text-gray-500 mt-1">
              Origem: {row.checklist_respostas?.checklist_perguntas_modelo?.texto_pergunta || 'Tarefa manual'}
            </p>
          </div>
        ),
      },
      {
        key: 'unidade',
        header: 'Unidade',
        render: (row) => {
          const unidadeNome =
            row.checklist_respostas?.checklist_execucoes?.unidades?.nome ||
            row.unidade?.nome ||
            unidades.find(
              (u) =>
                u.unidade_id ===
                (row.unidade_id || row.checklist_respostas?.checklist_execucoes?.unidade_id)
            )?.nome;

          return unidadeNome || 'N/A';
        },
      },
      {
        key: 'responsavel',
        header: 'Responsável',
        render: (row) => row.responsavel || 'Não atribuído',
      },
      {
        key: 'data_vencimento',
        header: 'Prazo',
        render: (row) => {
          const atrasado = row.status === 'ATRASADO';
          return (
            <span className={atrasado ? 'text-red-600 font-medium' : 'text-gray-700'}>
              {row.data_vencimento ? new Date(row.data_vencimento).toLocaleDateString() : 'N/D'}
            </span>
          );
        },
      },
      {
        key: 'status',
        header: 'Status',
        className: 'text-center',
        render: (row) => <StatusBadge status={row.status} />,
      },
      {
        key: 'acoes',
        header: 'Ações',
        className: 'text-center',
        render: (row) => (
          <div className="flex justify-center items-center gap-2">
            {row.status !== 'CONCLUIDA' ? (
              <button
                onClick={() => handleUpdateStatus(row, 'CONCLUIDA')}
                className="bg-green-500 text-white px-3 py-1 rounded-md text-xs font-bold hover:bg-green-600"
              >
                Concluir
              </button>
            ) : (
              <span className="text-xs text-gray-500">Finalizada</span>
            )}
            <button
              onClick={() => handleOpenModal(row)}
              className="text-gray-400 hover:text-purple-600 p-1"
              title="Editar"
            >
              <Edit className="h-4 w-4" />
            </button>
          </div>
        ),
      },
    ];
  }, [handleOpenModal, handleUpdateStatus, unidades]);

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      {/* Header e Ação */}
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold text-gray-800">Plano de Ação</h1>
        <button
          onClick={() => handleOpenModal()}
          className="bg-purple-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-purple-700 shadow-sm"
        >
          Nova Tarefa
        </button>
      </div>

      {/* KPIs */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <SummaryCard title="Pendentes" value={summaryData.pendentes} icon={<ListTodo className="h-6 w-6 text-yellow-600" />} colorClass="bg-yellow-100" />
        <SummaryCard title="Atrasadas" value={summaryData.atrasadas} icon={<AlertCircle className="h-6 w-6 text-red-600" />} colorClass="bg-red-100" />
        <SummaryCard title="Concluídas" value={summaryData.concluidas} icon={<CheckCircle2 className="h-6 w-6 text-green-600" />} colorClass="bg-green-100" />
      </div>

      {/* Filtros */}
      <div className="bg-white p-4 rounded-xl shadow-md mb-6 border border-gray-100 mx-4 md:mx-0">
        <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
          {/* Filtros */}
          <div className="flex flex-wrap items-center justify-center md:justify-start gap-2">
            {['PENDENTES', 'CONCLUIDA', 'TODOS'].map((status) => (
              <button
                key={status}
                onClick={() => setStatusFilter(status)}
                className={`px-3 py-2 text-sm font-semibold rounded-lg transition whitespace-nowrap
                  ${statusFilter === status
                    ? 'bg-purple-600 text-white shadow-sm'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}
                `}
              >
                {status === 'PENDENTES' ? 'Pendentes' : status === 'CONCLUIDA' ? 'Concluídas' : 'Todos'}
              </button>
            ))}
          </div>

          {/* Busca */}
          <div className="relative w-full md:w-auto">
            <Search className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" />
            <input
              type="text"
              placeholder="Buscar por tarefa, unidade..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-10 pr-4 py-2 w-full md:w-72 border border-gray-300 rounded-lg
                        focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
            />
          </div>
        </div>
      </div>

      {/* Tabela responsiva (desktop) / Cards (mobile) */}
      <ResponsiveListTable
        columns={columns}
        data={filteredPlanos}
        loading={loading}
        emptyMessage="Nenhuma tarefa encontrada."
        rowKey="plano_acao_id"
      />

      {/* Modal */}
      <PlanoAcaoModal
        open={isModalOpen}
        onClose={handleCloseModal}
        onSave={handleSavePlano}
        plano={currentPlano}
        unidades={unidades}
      />
    </div>
  );
};

export default PlanosPage;
